import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import ViewerIndex from '@/apps/public/pages/ViewerIndex.vue';
import ViewerDetail from '@/apps/public/pages/ViewerDetail.vue';

export const routes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'ViewerIndex',
      component: ViewerIndex,
   },
   {
      path: '/:id',
      name: 'ViewerDetail',
      component: ViewerDetail,
   },
];

const router = createRouter({
   history: createWebHistory(),
   routes,
});

export default router;
